import { render, staticRenderFns } from "./SimpleRequisiteDisplay.vue?vue&type=template&id=f5b54f94&"
import script from "./SimpleRequisiteDisplay.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisiteDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports